export enum InfrastructureStatusEnum {
    INFRST_UNKNOWN = 'INFRST_UNKNOWN',
    INFRST_COORDINATION_REQUIRED  = 'INFRST_COORDINATION_REQUIRED',
    INFRST_COORDINATION_NOT_REQUIRED = 'INFRST_COORDINATION_NOT_REQUIRED',
    INFRST_COORDINATION_RESTRICTIVE = 'INFRST_COORDINATION_RESTRICTIVE',
    INFRST_PERMANENTLY_CLOSED = 'INFRST_PERMANENTLY_CLOSED',

    INFRST_PARTIALLY_BLOCKED = 'INFRST_PARTIALLY_BLOCKED',
    INFRST_BLOCKED = 'INFRST_BLOCKED',
}